
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Play(props) {
    return (
        <SvgIcon {...props}>
            <path d="M38.9 256.4c0-41.8.1-83.6 0-125.4-.1-33.8-.3-67.5-.5-101.3 0-13 9.5-22.6 22.2-21.7 3.7.3 7.6 1.9 10.9 3.8 23.7 13.4 47.2 27 70.8 40.5 38 21.8 75.9 43.6 113.9 65.3C316.1 152.1 376 186.5 436 220.9c9 5.2 18.1 10.2 27.1 15.5 7.7 4.6 11.3 11.5 10.4 20.5-.7 7.1-4.6 12.3-10.6 15.8-29.7 17.3-59.3 34.6-89 52-51 29.8-102 59.6-152.9 89.3-49.4 28.8-98.8 57.7-148.2 86.5-15.8 9.2-32.3-.4-32.4-18.7-.2-67.7-.5-135.5-.7-203.2v-22.1c-.3-.1-.6-.1-.8-.1zm42.5 191.1C191.8 383.1 301.5 319 411.7 254.6 300.8 191 190.6 127.8 80 64.3c.5 127.9 1 255.1 1.4 383.2z" />
        </SvgIcon>
    );
}

Play.defaultProps = {
    viewBox: '0 0 512 512'
};

export default Play;
